var map = {
	"./Polygon 2.svg": "4c6c",
	"./alert.svg": "9a22",
	"./brand-logo.svg": "d44c",
	"./calendar.svg": "670f",
	"./email-icon.svg": "a511",
	"./facebook-icon.svg": "9402",
	"./facebook.svg": "a79d9",
	"./facebookLogo.svg": "f7a1",
	"./google-icon.svg": "e248",
	"./insta.svg": "b47d",
	"./instaLogo.svg": "f29d",
	"./instagram.svg": "3f07",
	"./ios-icon.svg": "07aa",
	"./loading-spin.svg": "3b2f",
	"./lock.svg": "5a00",
	"./logo.svg": "a8bf",
	"./mob-logo.svg": "9348",
	"./palasLogo.svg": "6bed",
	"./password.svg": "fecd",
	"./paypal-icon.svg": "1d73",
	"./phone.svg": "ea23",
	"./share.svg": "817f",
	"./socialLogo.svg": "6c5d",
	"./stat1.svg": "7fb8",
	"./stat2.svg": "35c9",
	"./stat3.svg": "e267",
	"./tiktok.svg": "de76",
	"./tiktokLogo.svg": "c4ab",
	"./trash.svg": "723f",
	"./warning.svg": "6d1d",
	"./waterDrop.svg": "d5c1",
	"./youtubeLogo.svg": "5aba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "af8c";